// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DBSearchFiltersCrms__container___xaIYm {
    display: flex;
    align-items: center;
    margin-bottom: 1.2rem;
}

.DBSearchFiltersCrms__text___hniuP {
    margin-right: 0.8rem;
}

.DBSearchFiltersCrms__field___TdROi {
    width: 100%;
    max-width: 39.9rem;
}

.DBSearchFiltersCrms__field___TdROi:not(:last-of-type) {
    margin-right: 0.8rem;
}
`, "",{"version":3,"sources":["webpack://./src/core/pages/Project/OverallImport/NewImportResults/DBSearchFilters/DBSearchFiltersCrms.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;AACxB","sourcesContent":[".container {\n    display: flex;\n    align-items: center;\n    margin-bottom: 1.2rem;\n}\n\n.text {\n    margin-right: 0.8rem;\n}\n\n.field {\n    width: 100%;\n    max-width: 39.9rem;\n}\n\n.field:not(:last-of-type) {\n    margin-right: 0.8rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `DBSearchFiltersCrms__container___xaIYm`,
	"text": `DBSearchFiltersCrms__text___hniuP`,
	"field": `DBSearchFiltersCrms__field___TdROi`
};
export default ___CSS_LOADER_EXPORT___;
